import { render, staticRenderFns } from "./RealFriendPrivacyPage.vue?vue&type=template&id=5f7a2c3f&scoped=true"
import script from "./RealFriendPrivacyPage.vue?vue&type=script&lang=js"
export * from "./RealFriendPrivacyPage.vue?vue&type=script&lang=js"
import style0 from "./RealFriendPrivacyPage.vue?vue&type=style&index=0&id=5f7a2c3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a2c3f",
  null
  
)

export default component.exports